// extracted by mini-css-extract-plugin
module.exports = {"button":"_1cUVf","dark":"hc6Gt","light":"_2_Nfo"};